// extracted by mini-css-extract-plugin
module.exports = {"infoWrap":"InvoiceInfo_infoWrap__1ISDP","labelCentered":"InvoiceInfo_labelCentered__3pLY-","radioLabel":"InvoiceInfo_radioLabel__1BGhb","labelAlt":"InvoiceInfo_labelAlt__1Dgz9"};